<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="PRODUCT ORDER CREATE" >
          <template slot="actions">
            <div class="flex">
            <vs-button v-can="'create-edit-order'" icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to orders
            </vs-button>
            <vs-button v-can="'create-edit-order'" icon-pack="feather" icon="icon-search" @click="onClickCheckCustomerPo" class="mr-4" color="warning" type="border">
              Check Customer PO
            </vs-button>
          </div>
          </template>
          <div slot="no-body" class="mt-4">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form autocomplete="off">

          <vs-table v-if="is_table_display" :hoverFlat="true" id="sample_list" v-can="'view-order'"  :data="staff"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container" noDataText="Search and add product to your cart">

              <template slot="header">

                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search here"
                          v-model="filters['search']" @keyup.enter="onPressEnter"
                          class="is-label-placeholder px-3 pb-5 w-full md:w-1/2 xl:w-1/7 rounded-full" />
                <span v-if="isHaveCreditAccount" class="text-danger text-lg	">Available credit ({{account_currency}}):  <b>{{creditDetails.available_credit | thousand_seperator}}</b></span>
                <vs-button id="place_order" :disabled="cartItems.length === 0" v-can="'create-edit-order'" icon-pack="feather" icon="icon-shopping-cart" @click="onClickPlaceOrder" class="mr-12" color="primary" type="filled">
                  View cart ({{cartItems.length}} Items)
                </vs-button>
              </template>

              <template slot="thead">
                <vs-th sort-key="formulation_code" width="15%">ITS PRODUCT CODE/NAME</vs-th>
                <vs-th sort-key="name" width="10%">CUSTOMER ITEM CODE/NAME</vs-th>
<!--                <vs-th width="10%">PRICE TYPE</vs-th>-->
                <vs-th width="10%">QUANTITY (KG)</vs-th>
                <vs-th width="10%" class="">UNIT PRICE (KG/{{account_currency}})</vs-th>
                <vs-th v-if="!__isCurrencyGbp(account_currency)" width="10%" class="">UNIT PRICE (KG/GBP)</vs-th>
                <vs-th width="15%" class="">PACK SIZE</vs-th>
                <vs-th width="10%" class="">INCOTERM</vs-th>
                <vs-th width="10%" class="">TOTAL PRICE ({{account_currency}})</vs-th>
                <vs-th width="10%" class="" v-can="'create-edit-order'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    <span class="font-bold">{{ data[indextr].formulation_code}}</span> <br>
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td>
                    <div v-if="data[indextr].customer_item_code !== 'N/A'">
                      <span class="font-bold">{{ data[indextr].customer_item_code}}</span> <br>
                      {{ data[indextr].customer_item_name }}
                    </div>
                    <div v-else> N/A </div>
                  </vs-td>

<!--                  <vs-td :data="data[indextr].type">-->
<!--                    {{ data[indextr].type}}-->
<!--                  </vs-td>-->

                  <vs-td :data="data[indextr].quantity">
                    <ValidationProvider v-if="data[indextr].type === 'List'" :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                      <vs-input v-on:input="onChangeQty(data[indextr],  indextr)"  type="text" v-model="data[indextr].quantity" class="w-full"
                                  :name="indextr+'quantity'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                    <!-- <span class="ml-2" v-if="['Contract', 'Bespoke'].includes(data[indextr].type)"> {{ data[indextr].quantity || '' }} </span> -->
                    <!-- wip -->
                    <span v-if="data[indextr].type === 'Contract'">
                      <ValidationProvider :vid="indextr + 'contract_quantity' " :name="indextr + 'contract_quantity'" :rules="'maxoq:'+data[indextr].contract_quantity" v-slot="{ errors }"
                    :custom-messages="{ maxoq:'Exceeds contract qty' }">
                      <vs-input v-model="data[indextr].quantity" :danger="!!errors[0]" :danger-text="errors[0]" @input="onInputBespokeContractQty(data[indextr], indextr)"  :name="indextr+'contract_quantity'" class="w-full"/>
                    </ValidationProvider>
                    </span>
                    <span v-if="data[indextr].type === 'Bespoke'">
                      <vs-input v-model="data[indextr].quantity" @input="onInputBespokeContractQty(data[indextr], indextr)" class="w-full"/>
                    </span>
                    <!-- end wip -->
                  </vs-td>

                  <vs-td :data="data[indextr].unit_price">
                    {{data[indextr].unit_price}}
                  </vs-td>

                  <vs-td  v-if="!__isCurrencyGbp(account_currency)" :data="data[indextr].price">
                    {{ data[indextr].type === 'List' ? calculateProductListPrice(data[indextr].pe_g, data[indextr].quantity) : (data[indextr].unit_price ? (Number(data[indextr].unit_price) / (Number(data[indextr].fx_rate) || 1)).toFixed(2) : '0.00') }}
                  </vs-td>

                  <vs-td :data="data[indextr].pack_size">
                    <v-select  v-on:input="onChangePackSize(data[indextr],  indextr)"  :clearable="true" placeholder=""  v-model="data[indextr].pack_size" :appendToBody="true"
                               :options="pack_size_options" label="size" :reduce="option => option.size"
                               :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                    <!-- <span v-if="customer_pack_sizes.length !== 0">
                      {{ customerPackSizeFactory(data[indextr].formulation_type) }}
                    </span> -->
                  </vs-td>

                  <vs-td :data="data[indextr].incoterm">
                    <v-select v-on:input="onChangeQty(data[indextr],  indextr)"  :clearable="true" placeholder=""  v-model="data[indextr].incoterm" :appendToBody="true"
                               :options="incoterms" label="code" :reduce="option => option.code"
                               :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                  </vs-td>

                  <vs-td>
                    {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                  </vs-td>


                  <vs-td v-can="'create-edit-order'">
                    <div class="vx-row">
                      <vx-tooltip :text="`Remove ${tr.formulation_code} from cart`" position="top">
                        <vs-button class="mr-2" :id="'remove_button'+''+ indextr" v-if="checkItemInCart(data[indextr])" @click.native="onClickRemoveFromCart(data[indextr].id, indextr)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Contract', 'Bespoke'].includes(data[indextr].type)" text="Update Quantity & View Pricing Tiers" position="top">
                        <vs-button class="mr-2" :id="'add_button'+''+ indextr" @click.native="onClickCalculatePrice(data[indextr], indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye">Price Tiers</vs-button>
                      </vx-tooltip>
                      <!-- <vx-tooltip class="mt-1" :text="`${data[indextr].type} Price`" position="top" v-if="data[indextr].type !== 'List'">
                        <vs-button @click.stop=""
                                   size="small" color="warning" type="filled">
                          {{ data[indextr].type === 'Bespoke' ? 'B' : data[indextr].type === 'Contract' ? 'C' : ''}}
                        </vs-button>
                      </vx-tooltip> -->
                    </div>
                  </vs-td>

                </vs-tr>
                <vs-tr v-if="staff.length > 0">
                  <vs-td style="font-weight: bolder">Total</vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td v-if="!__isCurrencyGbp(account_currency)"></vs-td>
                  <vs-td colspan="2"></vs-td>
                  <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                  <vs-td></vs-td>
                </vs-tr>
              </template>


            </vs-table>
              </form>
            </ValidationObserver>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-sample-order-pop-up v-bind:creditDetails="creditDetails" v-bind:sales_quote_id="sales_quote_id" v-bind:create_from_sales_quote="create_from_sales_quote" v-bind:account_currency="account_currency" :customer_po="customer_po" ref="createCustomerSampleOrderPopUp"/>
    <customer-credit-check-pop-up v-on:openCreditLimitRequest="openCreditLimitRequest" v-on:refreshData="refreshData" v-on:onlyRefreshData="onlyRefreshData" ref="customerCreditCheckPopUp"/>
    <create-customer-account-limit-request-pop-up v-bind:account_currency="account_currency" ref="createCustomerAccountLimitRequestPopUp" />
    <calculate-product-price-pop-up @changeQtyLayer="changeQtyLayer" ref="calculateProductPricePopUp" v-bind:account_currency="account_currency"/>
    <product-order-customer-po-check-pop-up @set-customr-po="setCustomerPo" ref="productOrderCustomerPoCheckPopUp"/>
    <vs-prompt
      title="Custom Pack Size"
      acceptText="Save"
      @cancel="active_custom_pack_size_prompt = false"
      @accept="submitCustomPackSize"
      @close="active_custom_pack_size_prompt = false"
      :active.sync="active_custom_pack_size_prompt">
      <div class="con-exemple-prompt">
        <span>Enter the value</span>
        <vs-input v-model="custom_pack_size_val" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <!-- Powder Quantity Warning Popup -->
    <vs-prompt
      title="Powder Product - Quantity Warning"
      :accept-text="'Close'"
      :cancel-text="''"
      color="warning"
      @close="powder_qty_warning_active = false"
      :active.sync="powder_qty_warning_active">
      <div class="con-exemple-prompt">
        <span>This is a <strong>powder product</strong>. It is recommended to order in multiples of <strong>10 kg</strong> (e.g. 10, 20, 30…). The item has been added to the cart - please review the quantity if needed.</span>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import CreateCustomerSampleOrderPopUp from '@/components/popups/customer/product-orders/CreateCustomerSampleOrderPopUp'
  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import CalculateProductPricePopUp from "@/components/popups/customer/product-orders/CalculateProductPricePopUp";
  import ProductOrderCustomerPoCheckPopUp from "@/components/popups/customer/product-orders/ProductOrderCustomerPoCheckPopUp"

  const CustomerRepository = RepositoryFactory.get('customer')
  const IncotermRepository = RepositoryFactory.get('incoterm')
  const PackSizeRepository = RepositoryFactory.get('pack_size')


  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        // customerId: '',
        cartItems: [],
        creditDetails: {},
        isHaveCreditAccount: false,
        addresses: [],
        is_uk_based_customer: false,
        customer_po: '',
        pack_size_options: [],
        customer_pack_sizes: [],
        is_table_display: true,
        active_custom_pack_size_prompt: false,
        custom_pack_size_val: 0,
        temp_data: {},
        default_incoterm: null,
        powder_qty_warning_active: false
      }
    },
    props: {
      account_currency  : {
        type: String,
        default: '',
      },
      customer_id: {
        type: String,
      },
      sales_quote_id: {
        type: String,
        default: ''
      },
      create_from_sales_quote: {
        type: Boolean,
        default: false
      },
    },
    components: {
      'v-select': vSelect,
      CreateCustomerSampleOrderPopUp,
      CustomerCreditCheckPopUp,
      CreateCustomerAccountLimitRequestPopUp,
      CalculateProductPricePopUp,
      ProductOrderCustomerPoCheckPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, Calculations],
    async mounted () {
      this.customerId = this.$route.params.id || this.customer_id
      await this.getAddresses()
      await this.getCreditDetails()
      await this.getIncoterms()
      await this.getPackSizeList()
      await this.getCustomerPackSizeSelection()
      await this.onClickCheckCustomerPo()
    },
    methods: {
      async onClickCheckCustomerPo() {
        await this.$refs.productOrderCustomerPoCheckPopUp.openPopup(this.customerId)
      },
      setCustomerPo(params) {
        this.customer_po = params
      },
      async refreshData () {
        await this.loadOnlyCartItemCatalogue()
        this.$emit('back')
      },
      async onlyRefreshData() {
        await this.loadOnlyCartItemCatalogue()
      },
      async openCreditLimitRequest() {
        await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.customerId)
      },
      async getCreditDetails() {
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit(this.customerId)
          this.creditDetails = data.data
          this.account_currency = this.creditDetails.customer_currency
          this.isHaveCreditAccount = true
        } catch (e) {
          this.isHaveCreditAccount = false
        }
      },
      async loadOnlyCartItemCatalogue() {
        try {
          await this.getItemsInItemsCart()
          const { data } = await CustomerRepository.getListOfCartProductCatalogue(
            { customer_id: this.customerId, formulation_ids: this.cartItems.map((x) => x.formulation_id) }
          )
          let staff_arr = data.data
          staff_arr = staff_arr.map((n) => {
            const second =  this.cartItems.find((m) => n.id === m.formulation_id )
            if(!!second) {
              n.quantity = second.quantity
              n.unit_price = second.price
              n.incoterm = second.incoterm
              n.pack_size = second.pack_size
            }
            return n
          })
          this.staff = staff_arr.filter((n) => !!n.quantity)

        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async loadProductCart() {

        try {
          await this.$vs.loading({
            container: '#sample_list',
            scale: 0.45
          })
          const {data} = await CustomerRepository.getListOfProductCatalogue(this.customerId,this.filterQuery)
          await this.getItemsInItemsCart()
          this.staff =  data.data.map((n) => {
            n.unit_price = ''
            return n
          })
          if (!!this.filters['search']) {
            this.staff = this.staff.map((n) => {
              const second =  this.cartItems.find((m) => n.id === m.formulation_id )
              if(!!second) {
                n.quantity = second.quantity
                n.unit_price = second.price
                n.incoterm = second.incoterm
                n.pack_size = second.pack_size
              } else {
                n.pack_size = this.isCustomerHasPackSize(n.formulation_type) ? this.customerPackSizeFactory(n.formulation_type) : null
              }
              n.incoterm = n.incoterm ? n.incoterm : this.default_incoterm
              return n
            })
          } else {
            let staff_arr = this.staff
            staff_arr = staff_arr.map((n) => {
              const second =  this.cartItems.find((m) => n.id === m.formulation_id )
              if(!!second) {
                n.quantity = second.quantity
                n.unit_price = second.price
                n.incoterm = second.incoterm
                n.pack_size = second.pack_size
              } else {
                n.pack_size = this.isCustomerHasPackSize(n.formulation_type) ? this.customerPackSizeFactory(n.formulation_type) : null
              }
              return n
            })
            this.staff = staff_arr.filter((n) => !!n.quantity)
          }


        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sample_list > .con-vs-loading')
      },

      async onClickCalculatePrice(data, index) {
        if(data.price.length === 0) {
          alert('error in price tiers')
          return
        }
        await this.$refs.calculateProductPricePopUp.openPopup(data, index, false, this.customerId)
      },
      async onInputBespokeContractQty(data, index) {
        if(data.type === 'Contract' && data.quantity > data.contract_quantity){
          return
        }
        this.openPriceTiersPopUp(data, index, this)
      },
      openPriceTiersPopUp: _.debounce( async (data, index, vm) => {
        await vm.onClickCalculatePrice(data, index)
      }, 1500),

      async onClickAddToCart(data, indextr) {
        await this.$vs.loading({
          container: `#sample_list`,
          scale: 0.45
        })
        try {
          const payload = {}
          payload.customer_id = this.customerId
          payload.formulation_id = data.id
          payload.quantity = data.quantity
          payload.price = (Number(data.unit_price)).toFixed(2)
          payload.type = data.type
          payload.incoterm = data.incoterm ? data.incoterm : this.default_incoterm
          // payload.pack_size = this.isCustomerHasPackSize(data.formulation_type) ? this.customerPackSizeFactory(data.formulation_type) : ( data.pack_size ? data.pack_size : this.pack_size_options[0].size ),
          payload.pack_size = data.pack_size ? data.pack_size : (this.isCustomerHasPackSize(data.formulation_type) ? this.customerPackSizeFactory(data.formulation_type) : this.pack_size_options[0].size)
          payload.pack_size = Number(payload.pack_size).toFixed(3)
          await CustomerRepository.addFormulationsToProductCart(payload)
          // await this.getItemsInItemsCart()
          this.filters.search =  ''
          this.showSuccessMessage('Product added')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async onClickRemoveFromCart(id, indextr) {
        await this.$vs.loading({
          container: `#remove_button${indextr}`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === id )
          await CustomerRepository.removeFormulationsFromProductCart(search.id)
          await this.loadOnlyCartItemCatalogue()
          this.showSuccessMessage('Product removed')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`)
      },
      async onClickUpdateFromCart(data, indextr) {
        await this.$vs.loading({
          container: `#sample_list`,
          scale: 0.45
        })
        try {
          const search = this.cartItems.find((n) => n.formulation_id === data.id )
          const payload = { 
            quantity: data.quantity, 
            price: data.unit_price, 
            incoterm: data.incoterm, 
            pack_size: Number(data.pack_size).toFixed(3)
          }
          await CustomerRepository.updateFormulationsQuantityInProductCart(search.id, payload)
          // await this.loadProductCart()
          this.filters['search'] =  ''
          this.showSuccessMessage('Product qty updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async getItemsInItemsCart() {
        await this.$vs.loading({
          container: '#place_order',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getItemsInProductCart(this.customerId)).data
          this.cartItems = data
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#place_order > .con-vs-loading')
      },
      async onClickPlaceOrder() {
        await this.$refs.createCustomerSampleOrderPopUp.openPopup(this.customerId, this.is_uk_based_customer)
      },

      filterQueryUpdate (){
        if(this.filters.search) {
          this.loadProductCart()
        } else {
          this.loadOnlyCartItemCatalogue()
        }
      },

      handleChangePage(page) {
        this.page=page;
        this.loadProductCart()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadProductCart()
        }
      },
      checkItemInCart: function (object) {
        const arr = this.cartItems.filter((n) => n.formulation_id === object.id)
        return arr.length > 0
      },
      totalCalculator() {
        let total = 0;
        this.staff.forEach((m) => {
          if (!!m.quantity && Number(m.unit_price) > 0) {
            total = total + Number(m.unit_price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      isPowderQtyValid(data) {
        if (!data.formulation_type) return true
        const type = String(data.formulation_type).toLowerCase()
        if (type !== 'powder') return true
        const qty = Number(data.quantity)
        return qty > 0 && qty % 10 === 0
      },
      async onChangeQty(row_data, index) {
        let data = {}
        Object.assign(data, row_data)
        if ((Number(data.quantity) < Number(data.min_order_quantity) && data.type === 'List') || !data.quantity) {
          return null
        }

        data.type = data.type === 'List' ? 'price' : 'contract'
        if(data.type === 'price') {
          const find = this.incoterms.find((x) => data.incoterm === x.code)
          const is_include_shipping_cost = find ? find.is_price_included : false
          let unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate, is_include_shipping_cost)
          this.staff[index].unit_price =  unit_price
          data.unit_price =  unit_price
        }
        const find = this.cartItems.find((m) => m.formulation_id === data.id)
        if(find) {
          this.updateCart(data, index, this)
        } else {
          this.addCart(data, index, this);
        }
      },
      async changeQtyLayer(e) {
        await this.onChangeQty(e.data, e.index)
      },
      addCart: _.debounce( async (data, index, vm) => {

        // Powder product: quantity must be a multiple of 10 (warning only, still proceeds)
        if (!vm.isPowderQtyValid(data)) {
          vm.powder_qty_warning_active = true
        }
        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }
        await vm.onClickAddToCart(data, index)
        await vm.loadOnlyCartItemCatalogue()
        // await vm.loadProductCart()
      }, 1500),
      updateCart: _.debounce( async (data, index, vm) => {

        // Powder product: quantity must be a multiple of 10 (warning only, still proceeds)
        if (!vm.isPowderQtyValid(data)) {
          vm.powder_qty_warning_active = true
        }
        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }
        if(!data.quantity) { return null }
        await vm.onClickUpdateFromCart(data, index)
        await vm.loadOnlyCartItemCatalogue()
        // await vm.loadProductCart()
      }, 1500),
      isCanAddOrderWithCredit() {
          if(this.creditDetails.account_type === 'proforma') {
            return true
          }
          const cart_total = this.totalCalculator()
          const available_credit = this.creditDetails.available_credit
          return (Number(cart_total) < Number(available_credit))
      },
      async openCreditCheckPopUp() {
        await this.$refs.customerCreditCheckPopUp.openPopup(this.customerId)
      },
      async getAddresses() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.customerId)).data.data;
        const find = this.addresses.find((x) => x.country === 'United Kingdom')
        this.is_uk_based_customer = !!find;
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async getIncoterms() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        try {
          const {data} = await IncotermRepository.getListOfIncoterms(1, '', 100, '')
          this.incoterms =  data.data
          this.default_incoterm = this.incoterms.find((x) => x.is_default).code
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async getPackSizeList() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        try {
          const {data} = await PackSizeRepository.getListOfPackSize(1, '', 100, '')
          this.pack_size_options =  data.data.map((x) => {
            x.size = this.__removeTrailingZeros(x.size)
            return x
          })
          this.pack_size_options.push({ size: 'custom size' })
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async getCustomerPackSizeSelection() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getCustomerDetails(this.customerId)).data
          this.customer_pack_sizes = data.pack_sizes && data.pack_sizes instanceof Array ? data.pack_sizes : []
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      customerPackSizeFactory(formulation_type) {
        let find = this.customer_pack_sizes.find((x) => x.formulation_type ===  formulation_type)
        return find && find.size !== null ? find.size : '0.000'
      },
      isCustomerHasPackSize(formulation_type) {
        let find = this.customer_pack_sizes.find((x) => x.formulation_type ===  formulation_type)
        return !!find
      },
      onChangePackSize(data, index) {
        if(data.pack_size !== 'custom size') {
          this.is_table_display = !this.is_table_display
          this.is_table_display = !this.is_table_display
          this.onChangeQty(data, index)
        } else {
          this.temp_data = { data, index }
          this.custom_pack_size_val = 0
          this.active_custom_pack_size_prompt = !this.active_custom_pack_size_prompt
        }
      },
      submitCustomPackSize() {
        try {
          this.active_custom_pack_size_prompt = false
          this.temp_data.data.pack_size = Number(this.custom_pack_size_val)
          this.is_table_display = !this.is_table_display
          this.is_table_display = !this.is_table_display
          this.onChangeQty(this.temp_data.data, this.temp_data.index)
        } catch (error) {
          this.convertAndNotifyError(error);
        }
      },
      onPressEnter() {
        alert('')
      }
    },
    watch : {
      page(){
        this.loadProductCart()
      }
    },
    computed: {
      customerId: function () {
        return this.customer_id
      },
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
